import React from "react";
import { Link } from "/navigation";

type Props = {
  universityName: string;
  universityURL: string;
  customHelperClass?: string;
};

export default function UniversityName({ universityName, universityURL, customHelperClass }: Props) {
  return (
    <h6 className={`font-family-lato fw-normal d-inline-block ${customHelperClass ?? ``}`}>
      <Link href={universityURL}>{universityName}</Link>
    </h6>
  );
}
